// extracted by mini-css-extract-plugin
export var marginNegative = "_70-5 _70-3 _70-1";
export var marginPositive = "_70-4 _70-3 _70-1";
export var modalContent = "_70-6";
export var samplesTable = "_70-8";
export var samplesTableContainer = "_70-7";
export var statBox = "_70-a";
export var tableCell = "_70-1";
export var tableCellCenter = "_70-2 _70-1";
export var tableCellRight = "_70-3 _70-1";
export var tableHeader = "_70-0";
export var trackingNumber = "_70-9";